import _ from 'lodash';

export default function useSortArray({ setter, keys }) {
  const sortBy = {};
  keys.forEach(key => {
    sortBy[key] = direction => d => setter(_.orderBy(d, key, direction));
  });
  return { sortBy };
}
